import { useLingui } from "@lingui/react/macro"
import { useFormikContext } from "formik"
import * as React from "react"

import {
  validateEmail,
  validateFirstName,
  validateJobTitle,
  validateLastName,
  validateSpend,
} from "../../utils/validation-v2"
import { getExpenseEstimateOptions } from "../form-options/options"
import DropdownField from "./dropdown-field"
import TextField from "./text-field"
import { useEmailsBlacklist } from "./use-emails-blacklist"

export function FirstNameField() {
  const { t } = useLingui()
  return (
    <TextField
      name="firstName"
      label={t`First name`}
      validate={validateFirstName}
    />
  )
}

export function LastNameField() {
  const { t } = useLingui()
  return (
    <TextField
      name="lastName"
      label={t`Last name`}
      validate={validateLastName}
    />
  )
}

export function JobTitleField({ className }: { className?: string }) {
  const { t } = useLingui()
  return (
    <TextField
      name="job_title_self_reported"
      label={t`Job title`}
      className={className}
      validate={validateJobTitle}
    />
  )
}

export const EmailField = ({
  className,
  emails,
}: {
  className?: string
  emails?: string[]
}) => {
  const { t } = useLingui()
  const { isValidating } = useFormikContext()
  const blacklist = useEmailsBlacklist()

  return (
    <TextField
      isValidating={isValidating}
      className={className}
      name="email"
      label={t`Work email`}
      validate={validateEmail(emails, blacklist)}
    />
  )
}

export const AnnualSpend = ({ className }: { className?: string }) => {
  const { t } = useLingui()
  return (
    <DropdownField
      className={className}
      name="self_reported_volume___select"
      placeholder={t`Select one...`}
      validate={validateSpend}
      options={[...getExpenseEstimateOptions()]}
      label={t`How much do you plan to spend on rewards and payouts annually?`}
    />
  )
}
